import { render, staticRenderFns } from "./Tutorial.vue?vue&type=template&id=a35e204c&scoped=true&lang=pug&"
import script from "./Tutorial.vue?vue&type=script&lang=ts&"
export * from "./Tutorial.vue?vue&type=script&lang=ts&"
import style0 from "./Tutorial.vue?vue&type=style&index=0&id=a35e204c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35e204c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VLayout})
